import React from "react";
import PropTypes from "prop-types";
import { CustomLink } from "../custom-link";
import "./story-tags.module.css";

function Tag({ tag }) {
  return (
    <CustomLink href={"/topic/" + tag.slug} styleName="tag">
      {tag.name}
    </CustomLink>
  );
}

Tag.propTypes = {
  tag: PropTypes.shape({
    slug: PropTypes.string,
    name: PropTypes.string
  })
};

function StoryTags({ tags }) {
  return (
    <div>
      {tags.map((tag, index) => (
        <Tag key={index} tag={tag} />
      ))}
    </div>
  );
}

StoryTags.propTypes = {
  tags: PropTypes.array
};

export { StoryTags };
